import React, { createContext, useContext, useState } from "react";

const NavbarStateContext = createContext();

export const NavbarStateProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);


  return (
    <NavbarStateContext.Provider value={{ drawerOpen, setDrawerOpen }}>
      {children}
    </NavbarStateContext.Provider>
  );
};

export const useNavbarStateContext = () => useContext(NavbarStateContext);
